"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DualRing = void 0;
var dual_ring_1 = require("./dual-ring");
Object.defineProperty(exports, "DualRing", { enumerable: true, get: function () { return dual_ring_1.DualRing; } });
//# sourceMappingURL=index.js.map